<template>
  <div class="flex w-32">
    <div class="flex flex-col justify-start items-center relative w-full text-base mx-0 my-2
        min-w-20">
      <img :src="getProfilePic" alt="" class="overflow-hidden rounded-full w-16 lg:w-20"
        @error="handleImageError">
      <span class="pt-0 pb-1 px-2 text-center text-base">{{ member?.name }}</span>
    </div>
  </div>
</template>

<script>
import defaultProfileImage from '@/assets/defaultProfileImage.js';

export default {
  name: 'MemberComponent',
  props: ['member'],
  data() {
    return {
      refreshValue: this.$store.state.content.refreshValue,
    };
  },
  computed: {
    getRefreshValue() {
      return this.$store.getters.getRefreshValue;
    },
    getProfilePic() {
      // eslint-disable-next-line global-require
      if (this.member.picture_profile?.small) {
        return `${this.member.picture_profile?.small}?_${this.getRefreshValue}`;
      }

      return defaultProfileImage;
    },
  },
  methods: {
    handleImageError(event) {
      // eslint-disable-next-line no-param-reassign
      event.target.src = defaultProfileImage;
    },
  },
};
</script>
